'use strict';

window.console || (window.console = {
	log: function log() {}
});
var MIKI_HD = window.MIKI_HD || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = 'paris-miki.com';
	var a = 'is-active';
	var v = 'is-visible';
	var c = 'is-current';
	var slideSpeed = '400';

	MIKI_HD = {
		va: {
			pathname: location.pathname,
			isEnglish: /^\/hd\/eng\//.test(location.pathname),
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (MIKI_HD.va.window.width < MIKI_HD.va.device.sp) {
						pos -= 80;
					} else {
						pos -= 140;
					}
				}
				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash: function easeScrollHash() {
			var hash = location.hash;
			if (hash) {
				$(window).on('load', function () {
					$('html, body').css('display', 'none');

					setTimeout(function () {
						$('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						if (MIKI_HD.va.window.width < MIKI_HD.va.device.sp) {
							pos -= 80;
						} else {
							pos -= 140;
						}

						$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			if (MIKI_HD.va.window.width > 768) {
				$(window).scroll(function (e) {
					var $this = $(e.currentTarget);
					var $footer = $('.footer-copy');
					var footerPos = $footer.offset().top + $footer.height();
					var thisScroll = $this.scrollTop();
					var pagetopPos = $this.height() + $footer.height() + thisScroll;

					if (thisScroll > '100') {
						$pagetop.addClass(v);
					} else {
						$pagetop.removeClass(v);
					}
					if (footerPos <= pagetopPos) {
						$pagetop.addClass('is-bottom');
					} else {
						$pagetop.removeClass('is-bottom');
					}
				});
			}
		},
		headerMenu: function headerMenu() {
			var _this2 = this;

			if (MIKI_HD.va.window.width > MIKI_HD.va.device.desktop) {
				$('.header-nav-menu-item').mouseenter(function (e) {
					var $this = $(e.currentTarget);
					$('.header-nav-menu-item').each(function (idx, ele) {
						if ($(ele) !== $(_this2)) {
							$(ele).removeClass(a);
							$(ele).find('.header-nav-menu-body').stop().slideUp(slideSpeed);
						}
					});
					$this.addClass(a);
					$this.find('.header-nav-menu-body').stop().slideDown(slideSpeed);
				});
				$('.header-nav-menu-item').mouseleave(function (e) {
					var $this = $(e.currentTarget);
					$this.removeClass(a);
					$this.find('.header-nav-menu-body').stop().slideUp(slideSpeed);
				});
			} else {
				$('.header-nav-menu-head.js-open').on('click', function (e) {
					if ($(e.currentTarget).hasClass(a)) {
						var $this = $(e.currentTarget);
						$this.removeClass(a);
						$this.next('.header-nav-menu-body').stop().slideUp(slideSpeed);
					} else {
						var _$this = $(e.currentTarget);
						$('.header-nav-menu-item').each(function (idx, ele) {
							if ($(ele) !== $(_this2)) {
								$(ele).removeClass(a);
								$(ele).find('.header-nav-menu-body').stop().slideUp(slideSpeed);
							}
						});
						_$this.addClass(a);
						_$this.next('.header-nav-menu-body').stop().slideDown(slideSpeed);
					}
					return false;
				});
				$('.header-hamburger').on('click', function (e) {
					$(e.currentTarget).toggleClass(a);
					$('.header-nav').stop().slideToggle(slideSpeed);
				});
				$('.header-nav-close').on('click', function () {
					$('.header-hamburger').removeClass(a);
					$('.header-nav').stop().slideUp(slideSpeed);
				});
			}

			// スクロールで縮小
			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var thisScroll = $this.scrollTop();
				if (thisScroll === 0) {
					$('.header').removeClass('is-small');
				} else {
					$('.header').addClass('is-small');
				}
			});

			// サイト内検索
			$('.header-nav-search-head').on('click', function () {
				$('.header-nav-search-head').toggleClass(a);
				$('.header-nav-search-form').toggleClass(a);
			});
			if (MIKI_HD.va.isEnglish) {
				$('.mf_finder_searchBox_query_input').attr('placeholder', 'Please enter a keyword');
			} else {
				$('.mf_finder_searchBox_query_input').attr('placeholder', '検索ワードを入力');
			}

			// footer(SP)
			if (MIKI_HD.va.isMobile) {
				$('.footer-nav-head.js-open').on('click', function (e) {
					$(e.currentTarget).toggleClass(a);
					$(e.currentTarget).next('.footer-nav-body').slideToggle(slideSpeed);
					return false;
				});
			}
		},
		headerCurrent: function headerCurrent() {
			$('.header-nav-menu-item').each(function (idx, ele) {
				if (MIKI_HD.va.pathname.indexOf($(ele).find('.header-nav-menu-head').attr('href')) !== -1) {
					$(ele).addClass(c);
				}
			});
		},
		sideNavCurrent: function sideNavCurrent() {
			if ($('.mod-sideNav-nav-list').length) {
				var flg = false;
				$('.mod-sideNav-nav-list').find('a').each(function (idx, ele) {
					if (MIKI_HD.va.pathname === $(ele).attr('href') || MIKI_HD.va.pathname.replace(/_backnumber/, '') === $(ele).attr('href')) {
						$(ele).addClass(c);
						flg = true;
					}
				});
				if (!flg) {
					// 下層ページ用
					$('.mod-sideNav-nav-list').find('a').each(function (idx, ele) {
						if (MIKI_HD.va.pathname !== $(ele).attr('href') && MIKI_HD.va.pathname.indexOf($(ele).attr('href')) !== -1) {
							$(ele).addClass(c);
						}
					});
				}
			}
		},
		siteSearch: function siteSearch() {
			(function () {
				var s = document.createElement('script');
				s.src = '/hd/common/js/siteSearch.js';
				document.getElementsByTagName('body')[0].appendChild(s);
			})();
		},
		gdpr: function gdpr() {
			if ($('.footer-gdpr').length) {
				if ($.cookie('miki_hd-gdpr-popup') !== 'hidden') {
					$('.footer-gdpr').addClass(a);
				}
				$('.footer-gdpr-accept').on('click', function () {
					$.cookie('miki_hd-gdpr-popup', 'hidden', { expires: 183, path: '/', secure: false });
					$('.footer-gdpr').removeClass(a);
				});
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.headerMenu();
			_this.headerCurrent();
			_this.sideNavCurrent();
			_this.siteSearch();
			_this.gdpr();
		}
	};

	$(function () {
		return MIKI_HD.localDecision() ? MIKI_HD.localLoading() : MIKI_HD.loadDelayScript();
	});
})(window.jQuery);